<template>
  <div class="cart">
    <div class="title">已添加的营养品</div>
    <div class="content">
      <div class="list">
        <SelectBjItem
          class="select-buji-item"
          v-for="(item, index) in data"
          :key="index"
          :data="item"
          :type="2"
          @del="bindDelPlan"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SelectBjItem from './select-buji-item.vue'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  components: { SelectBjItem },
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClickImage() {},
    bindDelPlan(item) {
      this.$emit('del', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.cart {
  padding: 20px 0px 56px;
  box-sizing: border-box;

  .title {
    padding: 0px 20px;
    padding-bottom: 4px;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
  }

  .list {
    padding-top: 16px;
    max-height: 300px;
    overflow-y: scroll;
    padding-bottom: 40px;

    .select-buji-item {
      margin-bottom: 20px;
    }

    .select-buji-item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
